import { useEffect } from "react";
import { monitorByMe, referredToMe } from "../../store/api/workItemsApi";
import { useDispatch, useSelector } from "react-redux";
import BihamtaTable from "../../../Components/BihamtaTable";
import { convertFromMoment, pWorkItemRelationType, pWorkItemTypesArray } from "../../../store/api/CommonFunctions";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { fixDateFilters, getTableColumns, tableColumns } from "./helper";
import SearchFilters from "./SearchFilters";
import ExcelButton from "./ExcelButton";

export default function MonitorByMe({ type, isActive }) {
    const dispatch = useDispatch();
    const history = useHistory();
    const filterData = useSelector(state => fixDateFilters(state.workItems.workItemsMonByMeFilters));
    const title = pWorkItemTypesArray[type - 1];

    const search = (data) => {
        if (data) {
            data.CreationDateFrom = convertFromMoment(data.CreationDateFrom).date;
            data.CreationDateTo = convertFromMoment(data.CreationDateTo).date;
        }
        dispatch(monitorByMe({ ...data, Take: data?.Take ?? 10, Skip: 0  }));
    }
    const gotoWi = (row) => {
        history.push(`/Projects/CreateEditWorkItem/false/${row.ID}`);
    }
    useEffect(() => {
        if (isActive)
            search(filterData);
    }, [type, isActive])

    return (
        <>
            <SearchFilters defaultValues={filterData} onSubmit={search} />
            <div style={{ display: "flex", justifyContent: "end" }}>
                <ExcelButton actionUrl="MonitorByMe" filterData={filterData} tableCols={getTableColumns(type)} />
            </div>
            <BihamtaTable
                columns={getTableColumns(type)}
                className="mt-0"
                objectName="workItemsMonitorByMe"
                reducerName="workItems"
                filterData={filterData}
                rowClick={gotoWi}
                pageSizeList={[10, 20, 50, 100, 900]}
                hasPaging={true}
                searchMethod={data => dispatch(monitorByMe(data))} />
        </>
    )
}